import { FlexBox } from "components/Common/FlexBox"
import { BackButton } from "components/Common/BackButton"
import ChevronLeft from "components/Icons/ChevronLeft"
import { Fragment } from "react"
import PageTitleMealTypeSelection from "components/mealTypeSelection/PageTitleMealTypeSelection"

const Header = ({ onBack }: { onBack: () => void }) => {
  return (
    <Fragment>
      <FlexBox
        style={{ height: 44, padding: "9px 18px" }}
        $justify="space-between"
        $alignItems="center"
      >
        <BackButton onClick={onBack}>
          <ChevronLeft />
        </BackButton>
        <PageTitleMealTypeSelection />

        <BackButton></BackButton>
      </FlexBox>
    </Fragment>
  )
}

export default Header
